
import Select from './Select'

export const STATUSES = [
  { id: 'all', name: 'Acknowledged: All' },
  { id: 'true', name: 'Acknowledged' },
  { id: 'false', name: 'Not acknowledged' },
]

export default function AcknowledgedSelect(props) {
  return <Select {...props} options={STATUSES} />
}
